<template>
<div class="contact1">
    <img src="../assets/contact1Typo1.svg" class="typo typo1">
    <img src="../assets/contact1Typo2.svg" class="typo typo2">
</div>
</template>
    
<style scoped>
.contact1 {
    background-color: #0d00b4;
    overflow: hidden;
    height: 100vh;
}

.typo{
    position: absolute;
    left: 30px;
    width: 83vw;
    max-width: 350px;
}

.typo1{
    position: absolute;
    top: 17vh;
}

.typo2{
    position: absolute;
    top: calc(38vh + 85px);
}
</style>

<script setup>
import { useRouter } from 'vue-router'
const router = useRouter()
router.beforeEach(function(to, from, next){
    if(from.path == '/contact1' && to.path == '/main/27') {
    to.meta.transition = 'slide-left'
    from.meta.transition = 'slide'
    }
    else {
    to.meta.transition = 'slide'
    }
    window.removeEventListener("touchstart",startevent);
    window.removeEventListener("touchend", endevent);
    next();
});

function startevent(event) {
    if(event.touches.length === 1){
    start = event.touches.item(0).clientX;
    }else{
    start = null;
    }
}

function endevent(event) {
    var offset = 100;
    if(start){
    var end = event.changedTouches.item(0).clientX;
    if(end > start + offset){
        router.push('/main/27');
    }
    else if(end < start - offset ){
        router.push('/contact2');
    }
    }
}

var start = null;
window.addEventListener("touchstart",startevent);
window.addEventListener("touchend", endevent);
</script>